import { render, staticRenderFns } from "./PopupMaterialGraph.vue?vue&type=template&id=b8ede6be&scoped=true"
import script from "./PopupMaterialGraph.vue?vue&type=script&lang=js"
export * from "./PopupMaterialGraph.vue?vue&type=script&lang=js"
import style0 from "./PopupMaterialGraph.vue?vue&type=style&index=0&id=b8ede6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ede6be",
  null
  
)

export default component.exports